import {
  SOANoteType,
  SOADocumentDueDateType
} from '@/enums'

export default {
  data () {
    return {
      dueDateHiddenValue: [SOADocumentDueDateType.None],
      dueDate: ''
    }
  },
  computed: {
    branchRegion () {
      if (this.branchData && this.branchData.region && this.branchData.region.length > 0) {
        return this.branchData.region[0]
      }

      return null
    },
    currencyCode () {
      return this.branchRegion
        ? this.branchRegion.currency_code
        : '$'
    },
    currencyPrecision () {
      return this.branchRegion
        ? this.branchRegion.stmt_decimal_precision
        : 2
    },
    showDueDateTypeAlert () {
      return this.branchData &&
        this.formData.due_date_type === SOADocumentDueDateType.NetDays
    },
    dueDateTypeAlertTitle () {
      if (this.branchData && this.branchData.payment) {
        return this.$t('api.optFields.documentDueDateType.warning', {
          net_day: this.branchData.payment.net_day
        })
      }

      return ''
    }
  },
  methods: {
    $_handleDueDateType (noteType) {
      switch (noteType) {
        case SOANoteType.Debit:
          if (this.formData.due_date_type === SOADocumentDueDateType.None) {
            this.formData.due_date_type = SOADocumentDueDateType.Immediate
          }
          break
        case SOANoteType.Credit:
          this.formData.due_date_type = SOADocumentDueDateType.None
          this.dueDate = ''
          break
      }
    },
    $_calcDueDate () {
      if (!this.formData) {
        return
      }
      if (!this.formData.date) {
        return
      }

      switch (this.formData.due_date_type) {
        case SOADocumentDueDateType.None:
          this.dueDate = ''
          break
        case SOADocumentDueDateType.Immediate:
          this.dueDate = 'Immediate'
          break
        case SOADocumentDueDateType.NetDays:
          if (this.branchData && this.branchData.payment) {
            this.dueDate = this.$moment(this.formData.date)
              .add(this.branchData.payment.net_day, 'days')
              .format('YYYY-MM-DD')
          } else {
            this.dueDate = this.$moment(this.formData.date).format('YYYY-MM-DD')
          }

          break
      }
    }
  }
}
